export const sliderKeys = {
    all: ['slider'] as const,
    list: (queryId: string, params: Record<string, unknown>) => [...sliderKeys.all, queryId, params] as const
};

// Invalidations:
// invalidateSliderCaches (FE-280, from changeFavorite / getOrderItems / use-material-acl) → sliderKeys.all
